/**
 * Created by nothing on 15-09-2017.
 */
import {P404ComponentComponent} from "./component/p404-component/p404-component.component";
import {AppLayoutComponent} from "./layout/app-layout/app-layout.component";
import {SECURE_ROUTES} from "./secure_routes";
import {LoginComponent} from "./component/login/login.component";
import {AuthGuard} from "./login.guard";
import {Routes, RouterModule} from "@angular/router";
import {RegisterComponent} from "./component/register/register.component";

const appRoutes:Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full',},
  {path: 'login', component: LoginComponent, canActivate: [AuthGuard]},
  {path: 'register', component: RegisterComponent},
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    data: {title: 'Secure Views'},
    children: SECURE_ROUTES
  },
  {path: 'p404', component: P404ComponentComponent},
  {path: '**', component: P404ComponentComponent}
];

export const appRoutingProviders:any[] = [AuthGuard];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/app.routes.ts